// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"48":"242fa67d","123":"6cbc0539","159":"2d070c2f","295":"8a8880f4","852":"52fb416b"}[chunkId] + ".js";
};